export function SetValueOnObject(object: object, propertyName, value) {
    if (!object.hasOwnProperty(propertyName)) {
        console.log({ object, propertyName, value });
        throw ("Object does not have a '" + propertyName + "' as a property.");
    }
    object[propertyName] = value;
    return object;
}